var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio-player',{staticClass:"message-audio-attachment-view",attrs:{"file":_vm.attachment,"is-available":_vm.isAvailable,"processing-status":_vm.processingStatus},on:{"click":_vm.onUnlock}})}
var staticRenderFns = []

export { render, staticRenderFns }